/** Sum line-item amounts from Import / Export C&F bill list API payloads. */

export function sumBillDetailsAmounts(billDetails) {
  if (!Array.isArray(billDetails) || !billDetails.length) return 0;
  return billDetails.reduce(
    (sum, row) => sum + (Number(row?.amount) || 0),
    0,
  );
}

/** Line-item expenditure rows plus agency commission (same bill). */
export function getImportCnfBillRowTotal(row) {
  const fromDetails = sumBillDetailsAmounts(row?.bill_details);
  return fromDetails + (Number(row?.agency_commission) || 0);
}

export function getExportCnfBillRowTotal(row) {
  const fromDetails = sumBillDetailsAmounts(row?.bill_details);
  const headerTotal =
    (Number(row?.custom_expenses) || 0) +
    (Number(row?.agency_commission) || 0);
  return fromDetails + headerTotal;
}
